import { Box, Card, CardContent, Divider, Grid, List, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { useTranslation } from 'react-i18next'
import CardHero from '../../../../shared/components/frontoffice/CardHero'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'

dayjs.extend(relativeTime)

interface INovelty {
  id: number
  brand: any
  visibility: number
  title: string
  slug: string
  content: string
  image_url: string
  created_at: string
}

interface NoveltiesFeaturedProps {
  novelties: INovelty[]
  cutContent: (content: string) => string
}

// const CarouselContainer = styled('div')({
//   position: 'relative'
// })

const StyledCard = styled(Card)({
  boxShadow: 'none',
  backgroundColor: 'transparent'
})

const ContentFeed = styled(CardContent)({
  padding: '0px 0px 8px 0px',
  '&:last-child': {
    paddingBottom: 8
  }
})

export default function NoveltiesFeatured({ novelties, cutContent }: NoveltiesFeaturedProps) {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)

  if (novelties.length < 2) return null

  return (
    <>
      <Box display="flex" alignItems="center" pb={3}>
        <Typography variant="h6" sx={{ minWidth: 'fit-content' }}>
          {t('featured')}
        </Typography>
        <Divider sx={{ marginLeft: 2, flexShrink: 1 }} />
      </Box>
      <Grid container alignContent="flex-start" sx={isMobile ? { margin: '0px -12px', width: '100vw' } : { padding: '1rem' }}>
        <Grid item xs={isMobile && novelties.length >= 7 ? 8 : 12}>
          <Carousel centerSlidePercentage={isMobile ? 80 : 40} centerMode autoPlay showThumbs={false} interval={5000} infiniteLoop>
            {novelties.map(novelty => (
              <Box p={1} key={novelty.id}>
                <CardHero
                  type={3}
                  redirect={`/novedades/${novelty.slug}`}
                  cardBrandName={novelty.brand?.name || ''}
                  cardVisibility={novelty.visibility}
                  cardImage={`${import.meta.env.VITE_AWS_URL}/novelties/${novelty.image_url}`}
                  cardTitle={novelty.title}
                />
              </Box>
            ))}
          </Carousel>
        </Grid>
        {novelties.length >= 7 && isMobile && (
          <Grid item xs={4}>
            <StyledCard>
              <ContentFeed>
                <List component="nav">
                  {novelties.slice(-3).map(novelty => (
                    <Box pb={2} key={novelty.id}>
                      <CardHero
                        type={0}
                        redirect={`/novedades/${novelty.slug}`}
                        cardBrandName={novelty.brand?.name || ''}
                        cardVisibility={novelty.visibility}
                        cardImage={`${import.meta.env.VITE_AWS_URL}/novelties/${novelty.image_url}`}
                        cardTitle={novelty.title}
                        cardDescription={<div dangerouslySetInnerHTML={{ __html: cutContent(novelty.content) }} />}
                        cardDate={`${dayjs(novelty.created_at).fromNow()}`}
                      />
                    </Box>
                  ))}
                </List>
              </ContentFeed>
            </StyledCard>
          </Grid>
        )}
      </Grid>
    </>
  )
}
